import { Component } from '@angular/core';

@Component({
  selector: 'spark-core-unauthorised',
  templateUrl: './unauthorised.component.html'
})
export class UnauthorisedComponent {
  constructor() {}
}
